import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardSubtitle,
  CardText,
  CardDeck,
  Col,
} from "reactstrap";
import { connect } from "react-redux";

class SuperDash extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <div className="d-flex">
          <Col sm="12" md="12" lg="12" xl="12">
            <CardDeck className="d-flex gap-3">
              <Card
                onClick={() => this.props.history.push("/superuser/schools")}
                style={{ cursor: "pointer" }}
              >
                <CardImg
                  top
                  width="100%"
                  src="img/Elever_img.jpg"
                  alt="Card image cap"
                />
                <CardBody>
                  <CardTitle className="text-warning">
                    <strong>Skolor</strong>
                  </CardTitle>
                  <CardSubtitle />
                  <CardText>
                    Här administrerar du skolor och dess lärare och elever
                  </CardText>
                </CardBody>
              </Card>

              {this.props.auth.auth.roles === "Superuser" && (
                <Card
                  onClick={() => this.props.history.push("/superuser/courses")}
                  style={{ cursor: "pointer" }}
                >
                  <CardImg
                    top
                    width="100%"
                    src="img/Kurser_img.jpg"
                    alt="Card image cap"
                  />
                  <CardBody>
                    <CardTitle className="text-danger">
                      <strong>Kurser, moduler &amp; licenser</strong>
                    </CardTitle>
                    <CardSubtitle />
                    <CardText>
                      Här administrerar du kurser, moduler och licenser
                    </CardText>
                  </CardBody>
                </Card>
              )}

              <Card
                onClick={() =>
                  this.props.history.push("/superuser/invoicehistory")
                }
                style={{ cursor: "pointer" }}
              >
                <CardImg
                  top
                  width="100%"
                  src="img/Faktura_img.jpg"
                  alt="Card image cap"
                />
                <CardBody>
                  <CardTitle className="text-primary">
                    <strong>Orderhistorik</strong>
                  </CardTitle>
                  <CardSubtitle />
                  <CardText />
                </CardBody>
              </Card>

              {this.props.auth.auth.roles === "Superuser" && (
                <Card
                  onClick={() => this.props.history.push("/superuser/users")}
                  style={{ cursor: "pointer" }}
                >
                  <CardImg
                    top
                    width="100%"
                    src="img/Elever_img.jpg"
                    alt="Card image cap"
                  />
                  <CardBody>
                    <CardTitle className="text-secondary">
                      <strong>Användare</strong>
                    </CardTitle>
                    <CardSubtitle />
                    <CardText>Administration användare.</CardText>
                  </CardBody>
                </Card>
              )}
              <Card
                onClick={() =>
                  this.props.history.push("/superuser/notifications")
                }
                style={{ cursor: "pointer" }}
              >
                <CardImg
                  top
                  width="100%"
                  src="img/tembg.jpg"
                  alt="Card image cap"
                />
                <CardBody>
                  <CardTitle style={{ color: "#12445A" }}>
                    <strong>Notiser</strong>
                  </CardTitle>
                  <CardSubtitle />
                  <CardText>Administration notiser.</CardText>
                </CardBody>
              </Card>
              <Card
                onClick={() => this.props.history.push("/superuser/licenses")}
                style={{ cursor: "pointer" }}
              >
                <CardImg
                  top
                  width="100%"
                  src="img/templicenses.jpg"
                  alt="Card image cap"
                />
                <CardBody>
                  <CardTitle style={{ color: "#12445A" }}>
                    <strong>Licenshantering</strong>
                  </CardTitle>
                  <CardSubtitle />
                  <CardText>Administration licenser.</CardText>
                </CardBody>
              </Card>
            </CardDeck>
          </Col>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    auth: store.auth,
  };
};

export default connect(mapStateToProps)(SuperDash);
